<template>
  <router-view></router-view>
</template>

<script>
import axios from "axios";
import { ABILITY_TOKEN } from "@casl/vue";
import { fetchOUAccess } from "@/helpers/abilities.js";

export default {
  name: "App",
  inject: {
    $ability: { from: ABILITY_TOKEN },
  },
  components: {},
  methods: {
    loadOUAccess() {
      if (localStorage.getItem("jwt")) {
        let ouAccess = localStorage.getItem("ouAccess")
          ? JSON.parse(localStorage.getItem("ouAccess"))
          : [];
        if (ouAccess == undefined || ouAccess == null || ouAccess.length == 0) {
          fetchOUAccess();
        }
      }
    },
  },
  computed: {
    rules() {
      return this.$store.state.rules || [];
    },
  },
  created() {
    // axios global request interceptor
    axios.interceptors.request.use(function (config) {
      const token = localStorage.getItem('jwt');
      config.headers.Authorization = `Bearer ${token}`;
      
      return config;
    });

    // axios global response interceptor
    axios.interceptors.response.use(response => {
      return response;
    }, error => {
      

      // auto logout once we receive a 401 response
      if (error.response.status === 401) {
        axios.post(process.env.VUE_APP_AUTHDOMAIN + '/api/refresh').then(result => {
          if (result.data) {
            let authData = result.data.authorization;

            localStorage.setItem('jwt', authData.token);
            axios.defaults.headers.common['Authorization'] = `${authData.type} ${authData.token}`;
          }
          
          // localStorage.setItem('userdata', JSON.stringify(result.data.data.user));
          // localStorage.setItem('userid', result.data.data.user.id);
          // localStorage.setItem('user', JSON.stringify(result.data.data.user));
          // this.roles = result.data.data.user.roles.map(item => {
          //   return item.id;
          // }); 
          // localStorage.setItem('userRoles', JSON.stringify(this.roles));
          // this.$store.commit('setActiveOU', result.data.data.user.default_ou);
        }).catch((error) => {
          console.log(error);
          // Swal.fire("Failed!", "Invalid username and/or password","warning");
        })

        


        // localStorage.clear();
        // this.$router.push({ name: 'login' });
      }

      return error;
    });

    this.$store.commit("getRules");
    this.$ability.update(this.rules);
  },
  mounted() {
    this.loadOUAccess();
  },
};
</script>

<style>
.introjs-tooltip-header {
  display: none !important;
}

.introjs-tooltip {
  width: 300px !important;
}

.introjs-tooltiptext {
  background-color: rgb(10, 179, 156) !important;
  color: #fff !important;
}

.introjs-tooltipbuttons {
  background-color: rgb(255, 255, 255) !important;
  color: #292929 !important;
}

.introjs-nextbutton {
  color: #ffffff !important;
  background-color: rgba(10, 179, 156) !important;
}

.introjs-prevbutton {
  border: 1px solid gray !important;
  background-color: rgb(255, 255, 255) !important;
  color: gray !important;
}

.introjs-tooltiptext {
  font-size: 15px !important;
}

.introjs-button,
.introjs-button:hover,
.introjs-button:focus,
.introjs-button:active,
.introjs-disabled,
.introjs-disabled:focus,
.introjs-disabled:hover {
  outline: none !important;
  background-image: none !important;
  background-color: rgba(10, 179, 156);
  color: #ffffff;
  border: 1px solid transparent;
  border-radius: 0px !important;
  box-shadow: none !important;
  text-shadow: none !important;
}
</style>